export default __webpack_public_path__ + "static/media/IMG5810.e0537f3f.jpg";